import React from 'react';

const Phone: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path
      d="M17.4997 32.5H22.4997M14.1663 4.16663H29.1663V32.5C29.1663 33.384 28.8151 34.2319 28.19 34.857C27.5649 35.4821 26.7171 35.8333 25.833 35.8333H14.1663C13.2823 35.8333 12.4344 35.4821 11.8093 34.857C11.1842 34.2319 10.833 33.384 10.833 32.5V7.49996C10.833 6.6159 11.1842 5.76806 11.8093 5.14294C12.4344 4.51782 13.2823 4.16663 14.1663 4.16663Z"
      stroke="#0D0D0D"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export default Phone;
